export default `
<div class="ethics-doc">
  <h3 class="ethics-title">윤리규범</h3>

  <h4 class="ethics-chapter">제 1 장 총칙</h4>
  <div class="ethics-intro">
    <p>(주)이모션글로벌 (이하 '회사'라 함)은 회사의 경영이념을 근간으로 고객, 구성원, 주주, Business Partner, 사회 등 다양한 이해관계자의 가치를 창출함으로써 사회·경제·문화 발전의 핵심적인 역할을 수행하고, 나아가 공공의 이익실현이 가능한 제품과 서비스를 제공하는 기업을 지향한다.</p>
    <p>회사는 언제나 고객과 함께 영속, 발전하기 위하여 바르게 생각하고 행동함으로써 기업의 사회적 책임을 다하고 이해관계자 및 국가와 인류의 공동이익을 추구한다.</p>
  </div>

  <h5 class="ethics-article">제 1 조 (목적)</h5>
  <p>본 규범은 회사의 올바른 행동과 가치판단 기준 및 이와 관련한 절차를 정함으로써 회사의 윤리적인 경영활동을 추진함에 그 목적이 있다.</p>

  <h5 class="ethics-article">제 2 조 (적용범위)</h5>
  <p>본 규범은 회사의 업무를 수행하는 모든 임직원에 대하여 적용하며, 이해관계자 및 Business Partner에게는 실천을 권장한다.</p>

  <h5 class="ethics-article">제 3 조 (용어의 정의)</h5>
  <ul class="ethics-list">
    <li>① "금품" 이라 함은 현금, 유가증권, 물품 및 기타 경제적인 이익을 말한다.</li>
    <li>② "향응·접대" 라 함은 식사, 주류, 스포츠, 오락, 향락 등의 수혜를 말한다.</li>
    <li>③ "편의" 라 함은 금품이나 향응·접대를 제외한 숙박 및 교통편 제공, 관광안내, 행사지원 등을 말하며, 수취인이 편의를 누리기 위해서 일반적으로 상대방에게 경제적인 손실이 발생하는 경우를 말한다.</li>
    <li>④ "사회통념상 용인되는 일반적인 경우" 라 함은 제공자가 자발적이고 순수한 의도로 행하고, 상호 부담이 없음이 사회관습상 인정되는 경우로서, 해당 행위 이외에는 다른 수단이나 방법이 없는 경우 등을 말한다.</li>
    <li>⑤ "이해관계자" 라 함은 회사 및 임직원의 행위나 의사결정에 의해서 영향을 받는 사내·외 개인이나 집단을 말한다.</li>
    <li>⑥ "Business Partner" 라 함은 회사와 거래관계를 갖는 개인이나 법인을 말한다.</li>
    <li>⑦ "신고자" 라 함은 금전, 선물, 향응·접대 등을 수취하였거나 이러한 사실을 인지하여 신고의 의무가 있는 임직원, 고객, Business Partner 등을 말한다.</li>
  </ul>

  <h4 class="ethics-chapter">제 2 장 구성원</h4>

  <h5 class="ethics-article">제 4 조 (규범준수)</h5>
  <ul class="ethics-list">
    <li>① 구성원은 회사의 규정, 실정법, 사회의 기본규범 및 양심에 반하는 행위를 하지 않는다.</li>
    <li>② 업무는 공정하고 정당한 방법으로 수행하며 규정과 관련 법규를 준수한다.</li>
    <li>③ 일상생활 및 업무와 관련하여 사회로부터 지탄받을 수 있는 비윤리적인 불법 행위를 하지 않는다.</li>
    <li>④ 업무와 관련하여 공정성을 저해할 수 있는 금전, 선물, 향응·접대 등 어떠한 형태의 경제적 이익도 받지 않는다. 단, 사회통념상 용인되는 일반적인 경우는 예외로 한다.</li>
    <li>⑤ 경조사 발생 시 청첩·부고 등을 Business Partner 등에게 고지하여 상대방에게 부담을 주는 행위를 하지 않는다. 또한, 임직원의 경조사항을 Business Partner 등에게 무리하게 통보하여 부담을 주는 행위를 하지 않는다.</li>
    <li>⑥ 회사의 재산을 개인용도로 사용하지 않고, 업무상 알게 된 회사의 정보를 외부로 누설 또는 제공하지 않는다.</li>
    <li>⑦ 임원은 사회적 책임을 명심하여 기회와 위험에 적극적으로 대처하고, 기업경영에 관한 국제적 기준에 따라 행동하고 솔선수범한다.</li>
    <li>
      ⑧ 회사는 직장 내 성희롱을 예방하기 위하여 성희롱 예방교육을 의무적으로 년간 1 회 이상 실시하고, 임직원은 이를 이수하여야 하며, 불미한 사태가 발생하였을 때에는 강력한 제재를 가한다.
      <ul class="ethics-sub-list">
        <li>1. 상대로 하여금 성적인 수치심을 유발하거나 고정된 성 역할을 강조하는 언행을 하지 않는다.</li>
        <li>2. 음담패설을 삼가고 회식 때 술이나 춤을 강요하지 않는다.</li>
        <li>3. 직장에서 인터넷, 컴퓨터통신이나 기타 매체를 통한 음란물을 보지 않는다.</li>
        <li>4. 직장 동료의 신체에 대한 성적인 평가나 비유를 하지 않는다.</li>
        <li>5. 고의적인 또는 불필요한 신체접촉을 하지 않는다.</li>
      </ul>
    </li>
    <li>⑨ 구성원은 자신의 권한과 책임을 명확히 인식하고 정직과 신뢰의 원칙에 입각하여 업무를 수행하여야 한다.</li>
    <li>⑩ 불법 컴퓨터 소프트웨어를 사용하지 않는다.</li>
    <li>⑪ 기타 객관적으로 비윤리적이라고 판단되는 행위는 하지 않아야 한다.</li>
  </ul>

  <h5 class="ethics-article">제 5 조 (신의성실)</h5>
  <ul class="ethics-list">
    <li>① 구성원은 회사의 경영이념에 따라 각자에게 부여된 역할을 성실히 수행한다.</li>
    <li>② 본인의 의사결정 및 행동에 의해 발생할 수 있는 위험을 예방하고, 문제발생 시 책임을 다한다.</li>
    <li>③ 동료 및 관련부서간 적극적인 협조와 원활한 의사소통을 위해 노력한다.</li>
    <li>
      ④ 직원 상호간에 금전이나 선물을 제공하는 행위는 원칙적으로 금지하고, 다음의 경우에는 예외로 한다.
      <ul class="ethics-sub-list">
        <li>1. 윗사람이 아랫사람에게 자발적으로 금전이나 선물을 제공하는 행위</li>
        <li>2. 생일 등 기념일에 부서원들 간에 자비로 선물을 제공하는 행위</li>
        <li>3. 대가성이 전혀 없는 순수한 감사표시의 선물을 제공하는 행위</li>
      </ul>
    </li>
    <li>⑤ 직원 상호간 경조사의 부조는 자발적으로 하며 사회통념에 따른다.</li>
    <li>⑥ 직원 상호간의 금전 대차는 금지하는 것을 원칙으로 하되, 불가피할 경우에는 금전 대차 당사자의 상사로부터 허락을 받아야 한다.</li>
    <li>⑦ 직원 상호간의 연대보증 및 상호보증 행위를 해서는 안된다.</li>
    <li>⑧ 직원 상호간에 부정한 청탁을 대가로 금품, 향응 등 어떠한 형태의 경제적 이익도 주고 받지 않는다.</li>
    <li>⑨ 본 규범을 이행함에 있어서 회사와 개인의 이익이 상충할 경우에는 회사 전체의 이익을 우선적으로 고려하여야 한다.</li>
  </ul>

  <h5 class="ethics-article">제 6 조 (상호존중)</h5>
  <ul class="ethics-list">
    <li>① 구성원 개개인은 서로 가치 있고 존엄한 존재임을 인식하고, 건전하고 행복한 직장 생활을 위하여 최선을 다한다.</li>
    <li>② 사회 기본규범이나 예의에 어긋나는 행위를 하지 않는다.</li>
    <li>③ 상·하급자 및 동료 간에 불손한 언동이나 비하하는 발언을 하지 않는다.</li>
    <li>④ 항상 단정하고 당당한 자세를 취하며, 상대방에게 혐오감을 주는 행위를 하지 않는다.</li>
    <li>⑤ 학벌, 성별, 종교, 연령, 출신지역 등에 따라 차등을 두지 않는다.</li>
    <li>⑥ 인사담당자는 승진·이동 등 인사관리상 불만을 예방할 수 있도록 주기적인 모니터링을 실시하여 피드백을 하여야 한다.</li>
  </ul>

  <h5 class="ethics-article">제 7 조 (능력개발)</h5>
  <ul class="ethics-list">
    <li>① 구성원은 회사의 비전을 달성해 나갈 수 있는 인재가 되기 위한 자기계발에 힘쓴다.</li>
    <li>② 상급자는 하급자의 적성과 소질을 고려하여 그에 필요한 충고와 지도를 아끼지 않으며, 하급자는 맡은 바 업무를 수행할 수 있는 능력을 스스로 계발한다.</li>
    <li>③ 회사는 독창적 사고와 자율적 행동이 촉진될 수 있도록 교육기회를 균등하게 제공한다.</li>
    <li>④ 업무와 관련해서 습득된 유·무형의 지식을 회사발전에 도움이 되도록 임직원이 함께 공유한다.</li>
    <li>⑤ 이에 회사는 구성원이 자발적이고 의욕적으로 근로생활을 할 수 있도록 제반환경을 조성하여야 한다.</li>
  </ul>

  <h5 class="ethics-article">제 8 조 (윤리규정의 실천)</h5>
  <p>회사는 다음 각 호에 따라 구성원의 윤리규정 실천 여부를 관리 및 감독한다.</p>
  <ul class="ethics-list">
    <li>① 회사는 구성원이 윤리규정을 올바르게 실천할 수 있도록 공지한다.</li>
    <li>② 회사는 구성원에게 매년 1 회 이상 윤리규정 실천서약서를 수취한다.</li>
    <li>③ 회사는 윤리규정에 대해 상담 및 신고할 수 있는 사내 신고센터를 구축한다.</li>
  </ul>

  <h4 class="ethics-chapter">제 3 장 고객</h4>

  <h5 class="ethics-article">제 9 조 (고객존중)</h5>
  <p>고객의 의견을 항상 경청하고, 고객의 정당한 요구는 적극적으로 수용하며, 고객을 모든 판단 및 행동의 척도로 삼는다.</p>

  <h5 class="ethics-article">제 10 조 (고객 희열)</h5>
  <ul class="ethics-list">
    <li>① 회사는 제품을 개발하는 과정에서 제품 완결성을 제고하기 위한 사전검증절차의 도입 등을 통해 고객이 만족할 수 있는 제품과 서비스를 제공한다.</li>
    <li>② 회사는 고객의 요구사항을 정확히 파악하기 위한 모든 노력을 다하며, 고객의 정당한 요구와 합리적인 제안을 적극적으로 수용하고 고객과의 약속은 반드시 지킨다.</li>
    <li>③ 회사는 고객이 합리적으로 제품과 서비스를 선택할 수 있도록 정확한 정보를 적시에 제공한다.</li>
    <li>④ 고객에 대한 정보는 고객의 동의가 있거나 법률상 허용되는 경우를 제외하고는 고객정보를 제공받은 목적 외의 용도로 이용하거나 제 3 자에게 제공하지 않는다.</li>
  </ul>

  <h4 class="ethics-chapter">제 4 장 주주</h4>

  <h5 class="ethics-article">제 11 조 (성실경영)</h5>
  <p>구성원은 회사의 정관과 사규 및 법령을 준수하여 성실히 경영함으로써 기업가치를 높이는데 최선을 다하여야 한다.</p>

  <h5 class="ethics-article">제 12 조 (주주권익보호)</h5>
  <ul class="ethics-list">
    <li>① 회사는 주주의 정당한 요구 및 제안을 존중하여야 한다.</li>
    <li>② 회사는 재무제표 등 공시자료를 제반 법규 및 기업회계기준에 따라 작성하고 관련 법령에 따라 적시에 공시하여야 한다.</li>
  </ul>

  <h4 class="ethics-chapter">제 5 장 Business Partner</h4>

  <h5 class="ethics-article">제 13 조 (상생경영)</h5>
  <ul class="ethics-list">
    <li>① 회사는 공정하고 합리적인 기준을 적용하여 Business Partner를 선정하고 거래에 필요한 정보를 공평하게 제공하여 서로에게 이익이 되도록 한다.</li>
    <li>② 회사는 교육, R&D 등의 지원을 통하여 Business Partner의 경쟁력 강화를 적극 지원하며, 상호신뢰의 기반 위에서 고객행복이라는 공동가치를 추구하는 전략적 동반자로 인식한다.</li>
    <li>③ 회사는 우월적 지위를 이용한 부당한 행위를 하지 않으며, 상호이익과 공동발전을 추구한다.</li>
  </ul>

  <h5 class="ethics-article">제 14 조 (정보보호)</h5>
  <ul class="ethics-list">
    <li>① 회사는 Business Partner의 정보와 영업비밀을 보호하여야 하며, Business Partner의 동의가 있거나 법률상 허용되는 경우를 제외하고는 제공받은 목적 외의 용도로 이용하지 않는다.</li>
    <li>② 회사는 Business Partner 등 타사의 정보나 영업비밀을 위법 또는 부당한 방법으로 취득하거나 사용하지 않는다.</li>
  </ul>

  <h4 class="ethics-chapter">제 6 장 사회</h4>

  <h5 class="ethics-article">제 15 조 (건전한 기업활동)</h5>
  <ul class="ethics-list">
    <li>① 회사는 지속적인 기술혁신 등을 통해 편리하고 풍요로운 사회를 구현함으로써 인간의 삶의 질을 향상시키고 나아가 인류의 행복에 공헌한다.</li>
    <li>② 회사는 지역사회의 건전한 문화형성 및 쾌적한 생활환경을 위해 최선을 다한다.</li>
  </ul>

  <h5 class="ethics-article">제 16 조 (환경친화)</h5>
  <p>회사는 환경보호 관련 국제기준 및 관련 법령, 내부규정 등을 준수하고, 환경친화적 경영을 실천한다.</p>

  <h5 class="ethics-article">제 17 조 (사회공헌)</h5>
  <p>회사는 사업지역의 기업시민으로서 자원봉사, 재난구호 등 사회봉사활동에 적극 참여하고, 임직원의 사회봉사활동 참여를 장려한다.</p>

  <h5 class="ethics-article">제 18 조 (정치적 중립)</h5>
  <p>회사는 개인의 참정권과 정치적 의사표현을 존중하고 회사의 자금, 인력, 시설 등을 정치적 목적으로 사용하는 일체의 정치활동을 인정하지 아니한다.</p>

  <h4 class="ethics-chapter ethics-supplement">부 칙</h4>
  <ul class="ethics-list">
    <li>① 이 규범은 2024년 12월 09일부터 제정한다.</li>
  </ul>
</div>
`;
